import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { reqGET } from '../../../Utils';
import { api_crud_base, api_list_route, data_interface, endpoints } from './Config';
import "../../../assets/dataTable.css";

import { getTokenInfo } from '../../../UseToken';

    // Gilberto added »
import {
	set_language,
	content_language, 

} from '../../../Utils';

import { language } from '../../WEBContent/Language';
    // « Gilberto added

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    //console.log('REVIEWERS', dados.info.reviewers[0].name)

    const [isloading, setLoading] = useState(true);
    const [isRedirect, /*setRedirect*/] = useState(false);

        // Gilberto added »
    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');
        // « Gilberto added

    const articles = useRef([]);
    const reviewers = useRef([]);

    //const [refresh, setRefresh] = useState(0);

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id_serch) => {

        let list_route = api_list_route(getTokenInfo().companycode)
        //console.log(list_route)
        //return await reqGET(`${api_crud_route}/${id_serch}`)
        return await reqGET(`${list_route}/${id_serch}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

            // Gilberto added »
        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }
            // « Gilberto added


        //if (props.location.state !== undefined) {
        fetchInfo(props.location.state.item['id_evento']).then(async () => {

            let lista_revs = await get_reviewers()
            //console.log('lista_revs->', lista_revs)
            reviewers.current = lista_revs

            let lista_arts = await get_articles(props.location.state.item['id'])
            //console.log('lista_arts->', lista_arts)
            articles.current = lista_arts
            //setRefresh(refresh + 1)

            //console.log('++++++++++', articles.current)

            setLoading(false)
        })
    }, [props]);

    const get_reviewers = async () => {
        let aReviewers = [];

        return await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
            .then(res => {
                //console.log(res.data)

                res.data.forEach(v => {
                    aReviewers.push({ label: v.name, label2: v.surname, value: v.id })
                });

                //set_reviewers(aReviewers)
                return aReviewers
                //console.log('REVIEWERS', aReviewers)
            })
            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    const get_articles = async (id) => {

        let aArticles = [];

        /* CHAMADA ARTIGOS */
        return await reqGET(`${api_crud_base}/submissions/${getTokenInfo().companycode}/list`)
            .then(res => {
                //console.log(res.data)
                res.data.forEach(x => {
                    let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }

                    if(x.info.id_cfp === id){
                        aArticles.push(aux);
                    }
                });
                return aArticles
            })

            .catch(erro => { console.log(erro); /*alert( language[ lang ].error ); */ }) //'Erro'
    }

    /*const handleSingleCheck = e => {

        //console.log(e.target)
        const { name, value } = e.target;
        console.log(name)
        console.log(value)

        //set_dados(aux.reviewers[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))

    }*/

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{ language[ lang ].loading }</h2>
                    <p>{ language[ lang ].loading }</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">Call For Papers</h2>
                    <p>Home / Call For Papers / {dados.info.name}</p>
                </div>

                <div className={`dash-cards-2 body`}>
                    <div className="card">
                        <div className="card-body">
                            <h2 className="dash-title">{dados.info.name}</h2>
                            <div className="div-break" />
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].type }</h4>
                                    <p>{dados.info.tipo}</p>
                                </span>
                            </div>

                            <div className="div-break"></div>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].description }</h4>
                                    <p>{dados.info.description}</p>
                                </span>
                            </div>

                            <div className="div-break"></div>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].max_numb_art_author }</h4>
                                    <p>{dados.info.authores.max_articles}</p>
                                </span>
                                <span className="flex-1">
                                    <h4>{ language[ lang ].accepted_languages }</h4>
                                    <p>{dados.info.articles.linguas.join('; ')}</p>
                                </span>
                                <span className="flex-1">
                                    <h4>{ language[ lang ].template }</h4>
                                    {
                                    dados.info.articles.template.map((v, key) => {
                                        //console.log(value)
                                        return (
                                            <div key={key}>
                                                <p><a href={v.path + v.source_name} download={v.name} target="_blank" rel="noreferrer">{v.name}</a></p>
                                            </div>
                                        )
                                    })
                                    }
                                </span>
                            </div>

                            <div className="div-break"></div>
                            <h2 className={dados.info.cfp.length > 0 ? "dash-title" : "d-none"}>Call for Papers</h2>
                            {
                            dados.info.cfp.map((elem, index) => {
                                if(elem.id !== props.location.state.item['id_cfp'])
                                    return ''
                                else {
                                    let aux_data_inicio = elem.data_inicio.filter((v) => v.estado = 'activo').pop()
                                    let aux_data_submissao = elem.data_submissao.filter((v) => v.estado = 'activo').pop()
                                    let aux_data_limite_fim = elem.data_limite_fim.filter((v) => v.estado = 'activo').pop()
                                    
                                    return(
                                        <span key={index}>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].cfp_name }</h4>
                                                    <p>{elem.name}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].cfp_description }</h4>
                                                    <p>{elem.descricao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].start_date }</h4>
                                                    <p>{aux_data_inicio.data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].submission_date }</h4>
                                                    <p>{aux_data_submissao.data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].end_date }</h4>
                                                    <p>{aux_data_limite_fim.data}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].sup_mat_deliv_date }</h4>
                                                    <p>{elem.data_marerial_suplementar}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].rev_resp_date }</h4>
                                                    <p>{elem.data_resposta_revisao}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].article_edit_deadline }</h4>
                                                    <p>{elem.data_limite_edicao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].rev_fin_dec_date }</h4>
                                                    <p>{elem.data_decisao_final_revisor}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].process_end_date }</h4>
                                                    <p>{elem.data_final_processo}</p>
                                                </span>
                                                <span className="flex-1">
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }
                            })
                            }

                            {/* <div className="div-break"></div>
                            <h2 className="dash-title">Artigos</h2>
                            {
                            dados.info.articles.list.map((elem, index) => {
                                if(elem.title === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.title}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            } */}
                        </div>

                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <img alt={ language[ lang ].back } src={'./img/seta_2.svg'} />
                                        <span>{ language[ lang ].back }</span>
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </main >
}